import React, { Component } from 'react';
import config from 'react-global-configuration';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


class StaffDebtPayments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      payment_date: '',
      id: this.props.staff_debt_payment_id,
      staff_debt_payments: [],
      modal: false,
    };

    this.debtLabel = this.debtLabel.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined' && typeof newProps.staff_debt_payment_id !== 'undefined') {
      this.setState({
        id: newProps.staff_debt_payment_id,
      });
    }
    if(Array.isArray(newProps.staff_debt_payments)) {
      this.setState({staff_debt_payments: newProps.staff_debt_payments});
    }
  }
  
  debtLabel (cell, row) {
    var botao = '';
    if (row.debt === 1 && row.credit === 1) {
      var botao = (
        <div className="btn-group">
          <p><i className="text-success fa fa-fw fa-warning"></i><i className="text-danger fa fa-fw fa-warning"></i></p>
        </div>
      );
    } else if(row.debt === 1) {
      var botao = (
        <div className="btn-group">
          <p className="text-danger"><i className="fa fa-fw fa-warning"></i></p>
        </div>
      );
    } else if(row.credit === 1) {
      var botao = (
        <div className="btn-group">
          <p className="text-success"><i className="fa fa-fw fa-warning"></i></p>
        </div>
      );
    }

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  <hr/>
  <BootstrapTable data={this.state.staff_debt_payments} pagination={true} striped={true} hover={true} options={{noDataText: 'Não há pagamentos em aberto'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
    <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
    <TableHeaderColumn dataField="aircraft_model" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Frota</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base Operacional</TableHeaderColumn>
    <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>
    <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Código de Controle</TableHeaderColumn>
    <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Período</TableHeaderColumn>
    <TableHeaderColumn dataField="revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Revisão</TableHeaderColumn>
    <TableHeaderColumn dataField="payment_type" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Tipo de Pagamento</TableHeaderColumn>
    <TableHeaderColumn dataField="payment_date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data do Pagamento;</TableHeaderColumn>
    <TableHeaderColumn dataField="debt_charge" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Desconto</TableHeaderColumn>
  </BootstrapTable>
</div>
    );
  }
}

export default StaffDebtPayments;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/Elements/StaffDebtPayments.js